"use strict";

define('model/upload',['./base', 'backbone', 'datakit/collection', 'FileAPI'], function (Base, Backbone, DKCollection, FileAPI) {
  var UploadModel = Base.extend({
    virtual: {
      name: Base.createKeyPathVirtual('file.name'),
      size: Base.createKeyPathVirtual('file.size')
    },
    defaults: {
      progress: 0,
      file: null,
      uploaded: false
    },
    initialize: function initialize(attrs, options) {
      options = options || {};
      this.uploadModel = options.uploadModel || Backbone.Model;
      Base.prototype.initialize.apply(this, arguments);
    },
    upload: function upload(options) {
      var headers = {},
        model = this,
        targetModel = new this.uploadModel(),
        xhr = null,
        progress = null;
      options = options || {};
      options.files = {
        file: this.get('file')
      };
      headers[window._csrf_header_name] = window._csrf_token;
      options.url = String(options.url || this.urlRoot);
      options.jsonp = 'iframe';
      options.headers = headers;
      if (_.isFunction(options.progress)) {
        progress = options.progress;
      }
      options.progress = function (ev, file, xhr, options) {
        var prog = ev.loaded / ev.total;
        if (!_.isNaN(prog)) {
          model.set('progress', prog);
          progress && progress(prog, ev, file, xhr, options);
        }
      };
      var promise = new Promise(function (resolve, reject) {
        options.complete = function (err, xhr) {
          if (err) {
            reject(err);
          } else {
            resolve(xhr);
          }
        };
        xhr = FileAPI.upload(options);
      }).then(function (xhr) {
        var resp = JSON.parse(xhr.responseText),
          data = targetModel.parse(resp);
        if (data && data.valid == false) {
          throw data.error;
        }
        targetModel.set(data);
        model.set('uploaded', true);
        model.trigger('complete', model, targetModel);
        return resp;
      })["catch"](function (err) {
        model.trigger('error', model, xhr, err);
      });
      return targetModel;
    }
  }, {
    createCollection: function createCollection(url, files, Model) {
      files = _.map(files, function (file) {
        return {
          file: file
        };
      });
      return new this.Collection(files, {
        uploadModel: Model,
        url: url
      });
    }
  });
  var UploadCollection = DKCollection.extend({
    model: UploadModel,
    initialize: function initialize(models, options) {
      options = options || {};
      DKCollection.prototype.initialize.apply(this, arguments);
      this.uploadModel = options.uploadModel || Backbone.Model;
      this.on('add', this.onAdd, this);
    },
    onAdd: function onAdd(model) {
      model.uploadModel = this.uploadModel;
    },
    totalPercent: function totalPercent() {
      var ratio = 100 / this.length,
        percent = 0;
      this.each(function (model) {
        percent += ratio * (model.get('progress') || 0);
      });
      return Math.round(percent);
    },
    upload: function upload(options) {
      var collection = new Backbone.Collection([], {
          model: this.uploadModel
        }),
        self = this,
        models = this.models.slice(),
        ev = _.extend({}, Backbone.Events),
        idx = -1;
      options = _.extend({
        url: this.url()
      }, options);
      function next() {
        idx++;
        if (idx >= models.length) {
          self.trigger('upload:complete', self, collection);
          return;
        }
        var model = models[idx];
        if (!model || model.get('uploaded') === true) {
          return next();
        }
        ev.listenTo(model, 'complete', function (model, targetModel) {
          ev.stopListening(model);
          collection.add(targetModel);
          next();
        }).listenTo(model, 'error', function () {
          var args = _.toArray(arguments);
          ev.stopListening(model);
        });
        model.upload(options);
      }
      ;
      _.defer(next);
      return collection;
    }
  });
  UploadModel.Collection = UploadCollection;
  return UploadModel;
});

